import React from "react";
import styles from "./Sidebar.module.css";
import logo from "../../assets/logo/oakawe.png";
import SidebarMenu from "./SidebarMenu";
import { SidebarData } from "./SidebarData";
import Sidebar1 from "./Sidebar1";
import { Box } from "@mui/system";

const Sidebar = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.sidebar_header}>
          <img src={logo} alt="" />
        </div>
        <div className={styles.sidebar_wrap}>
          <Sidebar1 />
          <Box sx={{ marginTop: 3,marginBottom:3, borderBottom: "2px solid #E8EFF4" }}></Box>
          {SidebarData?.map((item, index) => (
            <SidebarMenu item={item} key={index} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
